import { LatLngModel } from "@/api/Shared/LatLngModel";
import { MapBoundsModel } from "./MapBoundsModel";
import { WasteConfigurationModel } from "./WasteConfigurationModel";

export enum MapProvider {
  Old = 0,
  HereRaster = 1,
  HereVector = 2
}

export interface CouncilConfigurationModel {
  name: string;
  mapBounds: MapBoundsModel;
  mapCenter: LatLngModel;
  mapZoom: number;
  mapMinZoom: number;
  wasteConfiguration: WasteConfigurationModel[];
  searchRadiusKm: number;
  searchRadiusM: number;
  searchOrigin: LatLngModel;
  showRfid: boolean;
  state: string;
  country: string;
  propertyBoundaryMapName: string;
  isVideoRequestsEnabledForCouncilUsers: boolean;
  isVideoRequestsEnabledForJJRUsers: boolean;
  isPropertyBoundaryEnabledByDefault: boolean;
  enableCreateRequest: boolean;
  isHopperVideoEnabled: boolean;
  hideMonthlyReport: boolean;
  mapProvider: MapProvider;
  enableExportRequest: boolean;
}
